<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{header}}</h4>
          <a class="heading-elements-toggle">
            <i class="icon-ellipsis font-medium-3"></i>
          </a>
        </div>
        <div class="card-body">
          <div class="card-block">
            <p>{{subHeader}}</p>
            <p>
              <router-link :to="linkPath" class="btn btn-outline-secondary btn-min-width mr-1 mb-0">
                {{linkTitle}}
                <i class="icon-fast-forward2"></i>
              </router-link>
            </p>
          </div>
          <div class="table-responsive my-0">
            <b-table
              show-empty
              hover
              class="mb-0"
              :emptyText="failed?'Ошибка подключения. Попробуйте позже':'Записи отсутствуют'"
              :busy="busy"
              :tbody-tr-class="boldRow"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <strong>Загружаем...</strong>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <span
                  class="tag tag-default"
                  :class="{ 
                    'bg-warning bg-red bg-darken-2': data.value === 'Принята',
                    'bg-warning bg-darken-3': data.value === 'Обрабатывается',
                    'bg-green bg-darken-1': data.value === 'Выполнена',
                  }"
                >{{ data.value }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecentTable",
  props: {
    header: String,
    subHeader: String,
    linkPath: String,
    linkTitle: String,
    busy: Boolean,
    failed: Boolean,
    fields: Array,
    items: Array,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 5,
    };
  },
  computed: {
    totalRows() {
      return this.items ? this.items.length : 0;
    },
  },
  methods: {
    boldRow(item, type) {
      if (!item || type !== "row") return;
      if (item.new) return "font-weight-bold";
    },
  },
};
</script>